import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/core/logger.service';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { ErrCode } from 'src/app/shared/models';
import { ShareService } from 'src/app/shared/services/share.service';
import { IFile } from 'src/sync';

@Component({
  selector: 'app-preview-error',
  templateUrl: './preview-error.component.html',
  styleUrls: ['./preview-error.component.scss']
})
export class PreviewErrorComponent implements OnInit, OnDestroy {

  @Input() public errcode: ErrCode; 
  @Input() public syncId: number;
  @Input() public item: IFile;

  constructor(
    private loggerService: LoggerService,
    private router: Router,
    private rootLayoutConfigService: RootLayoutConfigService
  ) { }

  ngOnInit() {
    this.loggerService.error([
      'Preview encountered an error, location:',
      this.syncId,
      this.errcode.code,
      this.errcode.msg
    ].join(' '));

    if (this.errcode.code === 9500 || this.errcode.code === 9401) {
      this.rootLayoutConfigService.setErrCode(this.errcode.code);
    }
  }

  ngOnDestroy(): void {
    this.rootLayoutConfigService.setErrCode(null);
  }

  // TODO: Update redirection path to '/dashboard'
  goHome = () => {
    this.router.navigate(['/files']);
  }

  goLoginPage = () => {
    this.router.navigate(['/login']);
  }

  goSync = () => {
    window.open('https://www.sync.com/pricing', '_blank');
  }

}
